import { Dialog, VisuallyHidden } from '@buffer-mono/popcorn'

import type { IntegrationsContext, IntegrationsService } from '../../types'
import { SearchImagesForm } from '../search-images-form/SearchImagesForm'

import styles from './SearchImagesModal.module.css'

import type { JSX } from 'react'

export const SearchImagesModal = ({
  open,
  handleClose,
  service,
  context: editor,
  container,
}: {
  open: boolean
  handleClose: () => void
  service: IntegrationsService | null
  context: IntegrationsContext
  container?: HTMLElement | null
}): JSX.Element | null => {
  if (service === null) return <></>

  const handleOpenToggle = (nextOpen: boolean): void => {
    if (!nextOpen) handleClose()
  }

  return (
    <Dialog open={open} onOpenChange={handleOpenToggle}>
      <Dialog.Portal container={container}>
        <Dialog.Content
          className={styles.contentWrapper}
          onPointerDownOutside={handleClose}
          size="xlarge"
          portal={false}
        >
          <VisuallyHidden>
            <Dialog.Title>{service?.title} Image Search</Dialog.Title>
            <Dialog.Description>
              Search for images from {service?.title}
            </Dialog.Description>
          </VisuallyHidden>
          <SearchImagesForm editor={editor} service={service} />
          <Dialog.CloseButton />
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog>
  )
}
